
const digest = '1d4542be1e9e731a66a1baef48a144b05c796dde8de38f92aac1afc41645bf61';
const classes = {"wrapper":"_wrapper_1ua1e_1"};
const css = `._wrapper_1ua1e_1 {
  background-color: #ffffff;
  height: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  